import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import LoginPage from './pages/Login';
import BookingDashboard from './pages/dashboard';
import ProtectedRoute from './protectedRouteMiddleware'; // Import the ProtectedRoute component
import { AuthProvider } from './authMiddleware'
import NotFoundPage from './pages/pageNotFound';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <AuthProvider> {/* Wrap the entire app with AuthProvider */}
      <Router>
        <ScrollToTop />
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/admin/login" element={<LoginPage />} />
              {/* Protect the dashboard route */}
              <Route 
                path='/admin/dashboard' 
                element={
                  <ProtectedRoute>
                    <BookingDashboard />
                  </ProtectedRoute>
                } 
              />
              <Route 
                path='*'
                element={
                  <NotFoundPage />
                }
              />
            </Routes>
          </main>
          <Footer />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;